<template>
  <div>
    <v-autocomplete
      v-model="local.signer"
      :items="signers"
      item-value="euid"
      :item-text="item => item.chinStaffName + ((item.chinStaffName&&item.portStaffName)?' ':'') + item.portStaffName + (item.nickName?' ('+item.nickName+')':'') + ' ' + item.euid + (item.isAbsent?' - '+$t('Outbox.absence'):'')"
      hide-details
      :label="$t('Outbox.Signer')"
    />
    <!-- <v-select
      v-model="local.signer"
      :items="signers"
      item-value="staffCode"
      :item-text="item => item.chinStaffName + ' ' + item.portStaffName + (item.isAbsent?' ('+$t('Outbox.absence')+')':'')"
      hide-details
      :label="$t('Outbox.Signer')"
    /> -->
  </div>
</template>

<script>

import outboxApi from '@/api/outbox/outbox'

function getOficioSigners (inst) {
  outboxApi.getOficioSigners(resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.signers = resp.data
    }
  })
}

export default {
  props: {
    value: {
      type: Object,
      default: null
      // {
      //   ...
      //   signer: null
      // },
    }
  },
  data: () => {
    return {
      signers: []
    }
  },
  computed: {
    local () {
      return this.value ? this.value : {
        signer: null
      }
    }
  },
  created () {
    getOficioSigners(this)
  },
  methods: {
    // update (key, value) {
    //   this.$emit('input', { ...this.local, [key]: value })
    // }
  }
}
</script>
